import script from "./SecondPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecondPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SecondPageHeader.vue?vue&type=style&index=0&id=747ef52f&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747ef52f"]])

export default __exports__